import React from 'react';
import { bookingShape } from 'constants/propTypes';
import { withBooking } from 'components/queries/GetBookingQuery';
import { getAssistances, getValidExtras } from 'utils/booking';
import { StyledStickyContainer } from '../BookingDetails.styles';
import BookingDetailsTable from '../BookingDetailsTable';
import ModuleTabs from '../ModuleTabs';
import Extras from './Extras';

const Index = ({ booking, ...props }) => {
  const journeyExtras = [...booking.outboundExtras, ...booking.inboundExtras];
  const assistances = getAssistances(journeyExtras);

  const filteredExtras = [
    ...getValidExtras(booking.outboundExtras),
    ...getValidExtras(booking.insurances),
    ...getValidExtras(booking.hotels),
    ...getValidExtras(booking.inboundExtras),
    ...getValidExtras(booking.travelPassProducts)
  ];

  return (
    <>
      <StyledStickyContainer id="booking-details">
        <BookingDetailsTable booking={booking} />
        <ModuleTabs
          notes={booking.notes}
          reference={booking.reference}
          outbound={booking.nonExchangedOutbound}
          inbound={booking.nonExchangedInbound}
          assistances={assistances}
          extras={filteredExtras}
          booking={booking}
        />
      </StyledStickyContainer>
      <Extras booking={booking} {...props} />
    </>
  );
};

Index.propTypes = {
  booking: bookingShape
};

const options = {
  centerLoader: true
};
export default withBooking(Index, undefined, options);
